import { makeAutoObservable } from "mobx";
import {
  appendSystemMessageSession,
  clearSystemMessagesSession,
} from "../utils/systemMessagesSessionStorage";
import { notifySystemMessageLogged } from "./systemMessageNotify";

function normalizeMessageText(message) {
  return message
    .replace(/[{}"']/gm, "")
    .replace(/[:]/gm, ": ")
    .replace(/,/gm, ", ");
}

class Message {
  constructor() {
    makeAutoObservable(this);
  }
  // Сообщения
  messageVisible = true;

  id_message = 0;

  messages = [];

  // message
  writeMessages = (message) => {
    try {
      if (message === undefined) return;
      const normalized = normalizeMessageText(String(message));
      appendSystemMessageSession(normalized);
      notifySystemMessageLogged();
      const dublicate = this.messages.find((m) => m.message === normalized);
      if (!dublicate) {
        this.id_message = this.id_message + 1;
        this.messages = [
          ...this.messages,
          {
            id_message: this.id_message,
            message: normalized,
          },
        ];
      }
    } catch (e) {
      console.error(e);
    }
  };

  resetMessages = () => {
    this.messages = [];
    clearSystemMessagesSession();
  };

  deleteMessage = (id) => {
    this.messages = this.messages.filter((m) => m.id_message !== id.id_message);
  };
}

export default new Message();
